export default __webpack_public_path__ + "static/media/signUp.edab8c70.jpg";